module.exports = __webpack_public_path__ + "static/media/8OLA13.f28a9fa4.jpg";